<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">
        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
            <label>Código</label>
            <b-form-input type="text"
                          placeholder="Código"
                          v-model="form.cd"
                          name="cd"
                          >
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>

            <label>Descrição</label>
            <b-form-input type="text"
                          placeholder="Descrição"
                          v-model="form.descr"
                          name="descr"
                          >
            </b-form-input>
            <b-form-feedback class="text-danger" v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>

            <label>Grupo NCM</label>
            <multiselect v-model="grupoNcmSelected"
            :options="optionsGrupoNcm"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            ></multiselect>
            <b-form-feedback class="text-danger" v-text="form.errors.get('gruponcm_id')" v-if="form.errors.has('gruponcm_id')"></b-form-feedback>

            <label>Status</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.status"
                :options="optionsLivStatus"
                name="status"
                stacked
                plain
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback v-text="form.errors.get('status')"  v-if="form.errors.has('status')"></b-form-feedback>

        </form>

        <div slot="modal-footer" class="w-100">
               <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
               <div class="float-right">
                   <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                   <b-btn @click="showModal=false" variant="secondary">
                     Fechar
                   </b-btn>
                   <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                     Enviar
                   </b-btn>
               </div>
        </div>
    </b-modal>
</template>
<script>
import AvisoErros from '../components/AvisoErros'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
        modal_titulo: '',
        modal_botao: '',
        modal_acao: '',
        loading: false,
        isDisabled: false,
        loadingData: true,
        showModal: false,
        showModalGrupo: false,
        isFullscreen: false,
        grupoNcmSelected: [],
        optionsLivStatus: [],
        optionsLivStatusGrupo: [],
        optionsGrupoNcm: [],
        activateDesativate: [],
        errors_array: [],
        helpForm: new Form({
            statusRecord: [],
            params: []
        }),
        form: new Form({
            cd: '',
            descr: '',
            ncm_id: '',
            gruponcm_id: '',
            status: ''
        }),
        fields: [
          {
              name: '__checkbox',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          },
          {
            name: 'cd',
            title: 'Código',
            sortField: 'cd'
          },
          {
            name: 'descr',
            title: 'Descrição',
            sortField: 'descr'
          },
          {
            name: '__slot:status',
            title: 'Status',
            sortField: 'status'
          },
          {
              name: '__slot:actions',   // <----
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          }
      ],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
   }
},
watch: {
    grupoNcmSelected(obj) {
        this.form.gruponcm_id = obj.value;
    }
},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.ncm_id);
        }
    },
    onCreate() {
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Cadastrar";
        this.modal_botao = "Cadastrar";
        this.modal_acao = "i";
        this.form.reset();
        this.errors_array = '';
        this.errors_array = [];
        this.optionsLivStatus = [];
        this.optionsGrupoNcm = [];
        this.$parent.optionsLivStatus.forEach((obj)=>
        {
            this.optionsLivStatus.push({ text: obj.text, value: obj.value})
        })
        this.$parent.optionsGrupoNcm.forEach((obj)=>
        {
            this.optionsGrupoNcm.push({ label: obj.label, value: obj.value})
        })
        this.form.status = 1;
        this.grupoNcmSelected = [];
        this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Alterar";
        this.modal_botao = "Alterar";
        this.modal_acao = "u";
        this.form.reset();
        this.errors_array = '';
        this.errors_array = [];
        this.optionsLivStatus = [];
        this.optionsGrupoNcm = [];
        this.$parent.optionsLivStatus.forEach((obj)=>
        {
            this.optionsLivStatus.push({ text: obj.text, value: obj.value})
        })
        this.$parent.optionsGrupoNcm.forEach((obj)=>
        {
            this.optionsGrupoNcm.push({ label: obj.label, value: obj.gruponcm_id})
        })
        this.form.cd = data.cd;
        this.form.descr = data.descr;
        this.form.status = data.status.valor;
        this.grupoNcmSelected = {label: data.grupo_ncm.descr,value: data.grupo_ncm.gruponcm_id};
        this.form.ncm_id = id;
        this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/'+this.rota+'/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });

    },

    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
